/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PreviewAttachedFileAliases {
  IMAGE = 'image',
  LAYOUT_PREVIEW_FILE = 'layout-preview-file',
  PANEL_PREVIEW = 'panel-preview',
  PDF_VIEWER = 'pdf-viewer',
}
export { PreviewAttachedFileAliases };
